import { useState } from "react";
import { useV1FormsFormFamiliesCreate } from "@/api/generated/v1/v1";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { PageBanner } from "@/shared/components/PageBanner";

export function FormFamilyCreatePage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutateAsync: createFamily, isPending } = useV1FormsFormFamiliesCreate();

  const [formData, setFormData] = useState({ code: "", name: "" });
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMsg("");
    try {
      const res = await createFamily({ data: { code: formData.code, name: formData.name } });
      queryClient.invalidateQueries({ queryKey: ["v1FormsFormFamiliesList"] });
      navigate(`/forms/families/${(res as any).id}`);
    } catch (err: any) {
      setErrorMsg(err.response?.data?.detail || JSON.stringify(err.response?.data) || "خطا در ایجاد خانوادهٔ فرم");
    }
  };

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="ایجاد خانوادهٔ فرم"
        subtitle="تعریف یک فرم جدید با کد و نام یکتا"
        icon="✨"
        helpLink="/help/forms/families/create"
      >
        <div style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}>
          <button
            onClick={() => navigate("/forms/families")}
            style={{
              padding: "0.6rem 1rem",
              borderRadius: "12px",
              background: "rgba(255, 255, 255, 0.15)",
              color: "#ffffff",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              fontWeight: 700,
              fontSize: "0.85rem",
              cursor: "pointer",
            }}
          >
            ← انصراف
          </button>
        </div>
      </PageBanner>

      <div className="brand-card-extand" style={{ maxWidth: "600px", margin: "0 auto", padding: "2rem", width: "100%" }}>
        {errorMsg && (
          <div className="p-4 mb-4" style={{ background: "rgba(255,0,0,0.1)", borderLeft: "4px solid red", borderRadius: "8px" }}>
            <p style={{ color: "red" }}>{errorMsg}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          <div className="form-group">
            <label className="form-label">کد فرم <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              required
              className="input-field"
              value={formData.code}
              onChange={(e) => setFormData({ ...formData, code: e.target.value })}
              placeholder="مثال: QC-INSPECTION-IN"
              dir="ltr"
            />
          </div>

          <div className="form-group">
            <label className="form-label">نام فرم <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              required
              className="input-field"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="مثال: فرم بازرسی ورودی"
            />
          </div>

          <div className="flex-end mt-4">
            <button type="submit" className="btn btn-primary" disabled={isPending} style={{ width: "100%" }}>
              {isPending ? "در حال ایجاد..." : "ایجاد خانوادهٔ فرم و ادامه"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
